import React, { useEffect, useMemo } from 'react'
import * as classes from './CompanyNumbers.module.scss'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import { useDataCompanyNumbers } from './useDataCompanyNumbers'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { startAnimationScroll } from '../../../../utils/animations'
import { useDataCompanyNumbersByEn } from './useDataCompanyNumbersByEn'
import splitTitleV2 from '../../../../utils/splitTitleV2'

function CompanyNumbers({ lang }) {
    const dataByHy = useDataCompanyNumbers()
    const dataByEn = useDataCompanyNumbersByEn()

    const data = lang === 'hy' ? dataByHy : dataByEn

    const sectionTitle = useMemo(() => deleteHtmlTag(data.sectionTitle.value, 'p'), [])
    const investmentsTitle = useMemo(() => deleteHtmlTag(data.investmentsTitle.value, 'p'), [])
    const investmentsText = useMemo(() => deleteHtmlTag(data.investmentsText.value, 'p'), [])

    const apartmentsTitle = useMemo(() => deleteHtmlTag(data.apartmentsTitle.value, 'p'), [])
    const apartmentsText = useMemo(() => deleteHtmlTag(data.apartmentsText.value, 'p'), [])

    const investmentsItems = useMemo(
        () => [
            {
                count: deleteHtmlTag(data.investmentsItemTitle_1.value, 'p'),
                title: deleteHtmlTag(data.investmentsItemText_1.value, 'p')
            },

            {
                count: deleteHtmlTag(data.investmentsItemTitle_2.value, 'p'),
                title: deleteHtmlTag(data.investmentsItemText_2.value, 'p')
            }
        ],
        []
    )

    const apartmentsItems = useMemo(
        () => [
            {
                count: deleteHtmlTag(data.apartmentsItemTitle_1.value, 'p'),
                title: deleteHtmlTag(data.apartmentsItemText_1.value, 'p')
            },

            {
                count: deleteHtmlTag(data.apartmentsItemTitle_2.value, 'p'),
                title: deleteHtmlTag(data.apartmentsItemText_2.value, 'p')
            },

            {
                count: deleteHtmlTag(data.apartmentsItemTitle_3.value, 'p'),
                title: deleteHtmlTag(data.apartmentsItemText_3.value, 'p')
            },

            {
                count: deleteHtmlTag(data.apartmentsItemTitle_4.value, 'p'),
                title: deleteHtmlTag(data.apartmentsItemText_4.value, 'p')
            }
        ],
        []
    )

    const classAnimationTitle = 'anime-title-numbers'
    const classAnimationText = 'anime-text-numbers'

    useEffect(() => {
        splitTitleV2(classAnimationTitle)

        const observer = startAnimationScroll([
            { type: 'title', className: classAnimationTitle },
            { type: 'textFull', className: classAnimationText }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [])

    return (
        <section className={classes.Section}>
            <Container>
                {sectionTitle ? <SectionTitle className={classes.SectionTitle} title={sectionTitle} lang={lang} /> : null}

                <div className={classes.Inner}>
                    {investmentsTitle || investmentsText || (investmentsItems && investmentsItems.length) ? (
                        <div className={classes.Row}>
                            {investmentsTitle || investmentsText ? (
                                <div className={classes.Total}>
                                    {investmentsTitle ? (
                                        <p className={`${classes.TotalNum} ${classAnimationTitle} companyNumbers-anime-title`}>
                                            {investmentsTitle}
                                            <b>+</b>
                                        </p>
                                    ) : null}

                                    {investmentsText ? (
                                        <p
                                            className={`${classes.TotalText} ${classAnimationText}`}
                                            dangerouslySetInnerHTML={{ __html: investmentsText }}
                                        />
                                    ) : null}
                                </div>
                            ) : null}

                            {investmentsItems && investmentsItems.length ? (
                                <div className={classes.Details}>
                                    {investmentsItems.map((item, index) => (
                                        <div className={classes.DetailsItem} key={index}>
                                            {item.count ? (
                                                <span
                                                    className={`${classes.DetailsItemNum} ${classAnimationTitle} companyNumbers-anime-title`}
                                                    dangerouslySetInnerHTML={{ __html: item.count }}
                                                    data-html='Y'
                                                />
                                            ) : null}

                                            {item.title ? (
                                                <p
                                                    className={`${classes.DetailsItemText} ${classAnimationText}`}
                                                    dangerouslySetInnerHTML={{ __html: item.title }}
                                                />
                                            ) : null}
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    ) : null}

                    {apartmentsTitle || apartmentsText || (apartmentsItems && apartmentsItems.length) ? (
                        <div className={classes.Row}>
                            {apartmentsTitle || apartmentsText ? (
                                <div className={classes.Total}>
                                    {apartmentsTitle ? (
                                        <p className={`${classes.TotalNum} ${classAnimationTitle} companyNumbers-anime-title`}>
                                            {apartmentsTitle}
                                            <b>+</b>
                                        </p>
                                    ) : null}

                                    {apartmentsText ? (
                                        <p
                                            className={`${classes.TotalText} ${classAnimationText}`}
                                            dangerouslySetInnerHTML={{ __html: apartmentsText }}
                                        />
                                    ) : null}
                                </div>
                            ) : null}

                            {apartmentsItems && apartmentsItems.length ? (
                                <div className={`${classes.Details}`}>
                                    {apartmentsItems.map((item, index) => (
                                        <div className={classes.DetailsItem} key={index}>
                                            {item.count ? (
                                                <span
                                                    className={`${classes.DetailsItemNum} ${classAnimationTitle} companyNumbers-anime-title`}
                                                    dangerouslySetInnerHTML={{ __html: item.count }}
                                                    data-html='Y'
                                                />
                                            ) : null}

                                            {item.title ? (
                                                <p
                                                    className={`${classes.DetailsItemText} ${classAnimationText}`}
                                                    dangerouslySetInnerHTML={{ __html: item.title }}
                                                />
                                            ) : null}
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </Container>
        </section>
    )
}

export default CompanyNumbers
